import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import { useMutationUpdateBackgroundCheckSettings } from "../../../../../query/backgroundChecks/mutations/useMutationUpdateBackgroundCheckSettings";
import { getBackgroundChecksDefaultValues } from "./getBackgroundChecksDefaultValues";

type Params = {
  dataSourceId: string;
};

export const useEditBackgroundChecksRequirementDefinition = ({
  dataSourceId
}: Params) => {
  const [updateSettings, updateSettingsMeta] =
    useMutationUpdateBackgroundCheckSettings();

  const onSubmit = async (
    formValues: ReturnType<typeof getBackgroundChecksDefaultValues>
  ) => {
    await updateSettings(
      {
        instructions: formValues.instructions,
        dataSourceId
      },
      {
        throwOnError: true
      }
    );
  };

  return {
    onSubmit,
    ...updateSettingsMeta
  };
};
